import { useContext } from "react";
import Range from "../../CommonComponents/Range/Range";
import { AppContext } from "../../Context/AppContext";
import { saveKeyValue } from "../CommonWorkers";

function FontSizeSelect({ target }) {
	const { theme, setTheme } = useContext(AppContext);
	const options = [1, 1.25, 1.5, 1.75, 2];
	const selection = (e) => {
		if (e.target?.value) {
			setTheme((prev) => {
				let theme = { ...prev };
				theme[target] = e.target.value;
				return theme;
			});
			saveKeyValue(target, e.target.value);
		}
	};
	return (
		<div className='font-size-select-wrapper'>
			<div className='small-font'>AA</div>
			<Range currentValue={theme[target]} func={selection} />
			<div className='large-font'>AA</div>
		</div>
	);
}

export default FontSizeSelect;
